<template>
  <b-modal
    :id="`remove-insertion-order-modal-${insertionOrderId}`"
    :modal-class="'default-modal'"
    header-class="justify-content-between"
    :hide-footer="true"
    @hidden="hidden"
  >
  <template #modal-header="{ close }">
      <div class="text-center">
        <h2 class="highlighted-color1">
          <span>Remover PI</span>
        </h2>
      </div>
      <!--begin::Close-->
      <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close" @click="close()">
          <span class="svg-icon svg-icon-1">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
            </svg>
          </span>
      </div>
      <!--end::Close-->
    </template>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="mt-4">
      <h4 class="text-center mb-5">Tem certeza de que deseja remover o PI?</h4>
      <p>Ao remover um PI, todas as parcelas não pagas ou com notas fiscais não emitidas ou que possam ser canceladas (emissão no mês vigente) serão removidas.</p>
      <div class="mt-3 text-center">
        <Button
          class="btn btn-primary"
          @click="submit"
          :loading="loader"
        >
          Sim
        </Button>
      </div>
    </div>
  </b-modal>
</template>

<script>

import InsertionOrdersService from '@/modules/insertion-orders/services/insertion-orders-service'
import NotificationService from '@/modules/notifications/services/notifications-service'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'

export default {
  name: 'DestroyInsertionOrderModal',
  props: ['insertionOrderId'],
  components: {
    AlertWraper,
    Button
  },
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false
    }
  },
  methods: {
    /**
     * On modal hidden
     */
    hidden () {
      this.content = null
    },
    /**
     * Submit form
     */
    async submit () {
      this.loader = true
      try {
        await InsertionOrdersService.destroyInsertionOrder(this.insertionOrderId)
        const notification = {
          notification: {
            type: 'success',
            content: 'PI apagado com sucesso'
          }
        }
        NotificationService.createGlobalSuccessNotification(notification)
        this.$emit('destroyed', this.insertionOrderId)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    }
  }
}
</script>
